import { render } from "./Topbar.vue?vue&type=template&id=2eb86a57&lang=pug"
import script from "./Topbar.vue?vue&type=script&lang=ts"
export * from "./Topbar.vue?vue&type=script&lang=ts"
script.render = render

export default script